import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBasicParams, IBasicResponse} from "../../types/api"
import {IShipping} from "./ShippingTypes"
import {IShippingCreateParams, IShippingUpdateParams} from "./ShippingApiTypes"

export const shippingApi = createApi({
    reducerPath: "shippingApi",
    baseQuery,
    tagTypes: ["shipping"],
    endpoints: build => ({
        getShipping: build.query<IBasicResponse<IShipping[]>, IBasicParams>({
            query: () => `v1/shipping`,
            providesTags: ["shipping"]
        }),
        createShipping: build.mutation<IBasicResponse<void>, IShippingCreateParams>({
            query: ({lang, extra_price_per_km, fixed_price, distance_limit}) => ({
                method: "POST",
                url: `v1/shipping`,
                headers: {
                    "Accept-Language": lang,
                },
                body: {
                    extra_price_per_km,
                    fixed_price,
                    distance_limit
                }
            }),
            invalidatesTags: ["shipping"]
        }),
        updateShippingById: build.mutation<IBasicResponse<void>, IShippingUpdateParams>({
            query: ({lang, extra_price_per_km, fixed_price, distance_limit, id}) => ({
                method: "PUT",
                url: `v1/shipping/${id}`,
                headers: {
                    "Accept-Language": lang,
                },
                body: {
                    extra_price_per_km,
                    fixed_price,
                    distance_limit
                }
            }),
            invalidatesTags: ["shipping"]
        })
    })
})

export const {useGetShippingQuery, useCreateShippingMutation, useUpdateShippingByIdMutation} = shippingApi
